import React from 'react';

const RestaurantMenuInConstruction = () => <div className="p-3">
  <h1 className="h3">Tutaj powstaje strona restauracji <span className="text-primary">{restaurant.name}</span></h1>
  <p>Już niedługo będziesz mógł przejrzeć jej menu i zamówić coś dobrego online!</p>
  <div className="mt-3">
    <h2 className="h4">Jesteś głodny tu i teraz?</h2>
    <p>Zobacz <a href="/zamawiaj">listę restauracji</a>, w których możesz zamówić jedzenie w tej chwili, a tu wróć później :)</p>
  </div>
  <div className="mt-3">
    <h2 className="h4">Jesteś właścicielem restauracji?</h2>
    <div>Najprawdopodobniej jesteśmy właśnie w trakcie wprowadzania menu restauracji lub innych ustawień.</div>
    <div>Jeżeli masz wątpliwości - skontaktuj się z nami: <a href="mailto:hello@otostolik.pl">hello@otostolik.pl</a></div>
  </div>
</div>;

export default React.memo(RestaurantMenuInConstruction);
